export default __webpack_public_path__ + "static/media/envelope-regular.7df8d589.svg";